// extracted by css-extract-rspack-plugin
module.exports =  {"container":"JobRoot__container___knFA8","adjustHeight":"JobRoot__adjustHeight___T5bfA","fullHeight":"JobRoot__fullHeight___Vhpj7"};